// extracted by mini-css-extract-plugin
export default {"redirect":"storeRedirect_redirect__Zk0nj"};